"use strict";

exports.__esModule = true;
exports.wixPMobile = exports.wixP = void 0;

var wixP = function wixP(wixParam, isMobile) {
  return isMobile ? wixParam + "-mobile" : wixParam;
};

exports.wixP = wixP;

var wixPMobile = function wixPMobile(wixParam) {
  return wixP(wixParam, true);
};

exports.wixPMobile = wixPMobile;